export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/MobileHeroVideo-414a9e0583d76f2e08e2318a97939721.mp4";